import { statusTab } from "./orderStatuses";

// tm-admin-web-react RemoteSale tabs, as pages inside the sidebar's Order dropdown:
// Purchasing, Tracking, Sorting, Delivery, Invoice, Refunded. Each lists the orders in its
// own statuses (sub tabs, "All" = every status of that stage) and has the row actions tm has
// on that tab (see orderListActions.js).

// "All" = the stage's own statuses (the API takes a comma separated list)
const stageTabs = (statuses) =>
  statuses.length > 1 ? [{ label: "All", value: statuses.join(",") }, ...statuses.map(statusTab)] : statuses.map(statusTab);

export const ORDER_STAGES = [
  {
    slug: "purchasing",
    title: "Purchasing",
    subtitle: "Start and complete purchases",
    actionSet: "purchasing",
    statuses: ["Order Initiated", "Purchasing"],
    // Payment Date column + sort: the orders paid first are bought first (oldest payment on top by default)
    paymentDate: true,
  },
  // trackingNumbers: a Tracking Numbers column (the supplier tracking numbers saved on the order's shipment)
  { slug: "tracking", title: "Tracking", subtitle: "Update supplier tracking numbers", actionSet: "tracking", statuses: ["Purchase Completed", "Shipped From Supplier"], trackingNumbers: true },
  {
    slug: "sorting",
    title: "Sorting",
    subtitle: "Sort received parcels",
    actionSet: "sorting",
    statuses: ["Received In China Warehouse", "On The Way To China Airport", "Received In China Airport", "On The Way To BD Airport", "Received In BD Airport"],
    trackingNumbers: true,
  },
  // The Invoice page (/dashboard/invoice): print one or many invoices
  { slug: "invoice", title: "Invoice", subtitle: "Orders received in the BD warehouse - print invoices", actionSet: "delivery", statuses: ["Received In BD Warehouse"], trackingNumbers: true, invoicePrint: true },
  // The Delivery page (/dashboard/delivery). In the "Processing For Delivery" list many orders can be picked and
  // moved to "On The Way To Delivery" at once.
  {
    slug: "delivery",
    title: "Delivery",
    subtitle: "Complete payment and delivery",
    actionSet: "invoice",
    statuses: ["Processing For Delivery", "On The Way To Delivery", "Completed"],
    trackingNumbers: true,
    bulkMove: { fromStatus: "Processing For Delivery", toStatus: "On The Way To Delivery", label: "Move to On the Way to Delivery" },
  },
  { slug: "refunded", title: "Refunded", subtitle: "Refund requests and refunded orders", actionSet: "refunded", statuses: ["Processing For Refund", "Refunded"] },
].map((stage) => ({
  ...stage,
  path: `/dashboard/${stage.slug}`,
  tabs: stageTabs(stage.statuses),
  status: stage.statuses.join(","),
  // the page title is the stage name (not "<status> Orders")
  heading: stage.title,
}));
